var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgErrorFilled = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F04438",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.442,
    d: "M9.997 18.556a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.014 6.217a.97.97 0 1 0-1.94.002l.148 5.508h1.655l.136-5.51Zm-2.1 7.605a1.14 1.14 0 0 0 1.143 1.142c.608 0 1.128-.512 1.128-1.142 0-.615-.52-1.12-1.128-1.128-.63.007-1.15.512-1.143 1.128Z"
  })));
});
SvgErrorFilled.displayName = "SvgErrorFilled";
export default SvgErrorFilled;